export default __webpack_public_path__ + "static/media/sidemenu_doctor_my_availability.4ff5bef4.svg";